export default __webpack_public_path__ + "static/media/video_new_1.a31066ca.gif";